/**
 * Created by Ella Ma on 04/12/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { EntityBrief } from '../../../../tamalelibs/models/entity-brief.model';
import { AppConfig } from '../../../../tamalelibs/models/app-config.model';
import { Subscription, Subject, of as observableOf } from 'rxjs';
import { debounceTime, filter, take, catchError } from 'rxjs/operators';
import { EntityService } from '../../../../tamalelibs/services/entity.service';
import { EntityDropdownEventType, EntityDropdownConfig, EntityDropdownActionType } from './entity-dropdown.model';

@Component({
    selector: 'tam-entity-dropdown',
    templateUrl: './entity-dropdown.component.html',
    styleUrls: ['./entity-dropdown.component.scss']
})
export class EntityDropdownComponent implements OnInit, OnDestroy {

    @Input() config: EntityDropdownConfig;
    @Input() disabled?: boolean;
    @ViewChild('entitylist', { static: true }) entitylist;

    suggestionItems: Array<EntityBrief> = [];
    selectedItems: EntityBrief;

    private _page = 0;
    private _pageSize: number = AppConfig.searchingPageSize;
    private _source: Array<string>;

    private _filterHandler$: Subject<string> = new Subject();
    private _subscriptions$: Subscription[] = [];

    constructor(
        private _entityService: EntityService
    ) { }

    ngOnInit() {
        this._subscriptions$.push(
            this._filterHandler$.pipe(
                debounceTime(250),
                filter(filterStr => filterStr != null && filterStr.length > 0)
            ).subscribe(filterStr => this.searching(filterStr))
        );
        this.searching('');

        this._subscriptions$.push(
            this.config.actions$.pipe(
                filter(item => item.type === EntityDropdownActionType.search)
            ).subscribe(data => {
                this.selectedItems = data.payload;
                this.searching(data.payload.name);
            })
        );
    }

    ngOnDestroy() {
        this._subscriptions$.forEach(item => item.unsubscribe());
    }

    searching(text) {
        this._page = 0;
        this.entitylist.loading = true;
        this._subscriptions$.push(
            this._entityService.getEntityListBySearchTextQuick(++this._page, this._pageSize, text, this._source).pipe(
                take(1),
                catchError((e) => {
                    return observableOf();
                })).subscribe(res => {
                    this.suggestionItems = this.searchingDone(res);
                    this.entitylist.loading = false;
                })
        );
    }

    handleFilter(value) {
        this._filterHandler$.next(value);
    }

    searchingDone(entityList): Array<EntityBrief> {
        return this._entityService.mapEntityBriefList(entityList);
    }

    valueChange() {
        this.config.events$.next({ type: EntityDropdownEventType.valueChange, payload: this.selectedItems });
    }
}
